import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useRemoveBulkCurrentMedicationMutation } from "requests";

export const useRemoveMedications = (
  keys: (string | number)[],
  onSuccess: () => void
) => {
  const [remove] = useRemoveBulkCurrentMedicationMutation({
    ignoreResults: true
  });
  const { id: caseId } = useParams();
  const dispatch = useDispatch();

  const shouldSync = useCurrentCase(state => state.shouldSync);

  return () => {
    if (shouldSync) {
      return remove({
        variables: {
          input: {
            ids: keys.filter(key => typeof key === "number") as number[]
          }
        }
      }).then(() => {
        onSuccess();
        dispatch(
          casesActions.deleteCurrentMedications({ _id: caseId, data: keys })
        );
      });
    }

    dispatch(
      casesActions.deleteCurrentMedications({ _id: caseId, data: keys })
    );
    onSuccess();

    return Promise.resolve();
  };
};
